import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import { apiOptions } from '../../shared/constants/apiOptions';

import EndorsementsOverview from './pages/endorsements-overview';
import OpportunitiesOverview from './pages/opportunities-overview';
import ServiceRequestsOverview from './pages/service-requests-overview';
import TasksOverview from './pages/tasks-overview';

class PipelinesComponent extends Component {
  render() {
    return (
      <Router basename={apiOptions.pipelinesRouterBaseName}>
        <Switch>
          <Route exact path="/renewal-overview">
            <OpportunitiesOverview rootContainer={this.props.rootContainer} renewalOverview={true} />
          </Route>
          <Route exact path="/service-requests-overview">
            <ServiceRequestsOverview rootContainer={this.props.rootContainer} />
          </Route>
          <Route exact path="/endorsements-overview">
            <EndorsementsOverview rootContainer={this.props.rootContainer} />
          </Route>
          <Route exact path="/tasks-overview">
            <TasksOverview rootContainer={this.props.rootContainer} />
          </Route>
          <Route exact path="/opportunities-overview">
            <OpportunitiesOverview rootContainer={this.props.rootContainer} opportunitiesOverview={true} />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default PipelinesComponent;
